
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { getTimeAgo } from '@/utils/format';

@Component<InquiryRequestListItem>({})
export default class InquiryRequestListItem extends Vue {
	@Prop({ type: Object, required: true }) private request!: InquiryFormRequest;
	@Prop({ type: Boolean, required: true }) private selected!: boolean;

	private get formattedEventDate(): string {
		return DateTime.fromISO(this.request.event_date).toFormat('yyyy/LL/dd');
	}

	/**
	 * Calculate and format relative time since order submission.
	 *
	 * @return {string}
	 */
	private get orderSubmittedDate(): string {
		return `${this.$t('orders.inquiries.submitted')} ${getTimeAgo(this.request.created_at)}`;
	}
}
